















































import Vue from "vue";
export default Vue.extend({
  name: "NextMoveStartDescription",
  data() {
    return {
      title: "Here's how it Works"
    };
  }
});
